<template>
  <tr v-if="isMobile">
    <th
      :id="`th-label-${uid}`"
      colspan="4"
    >
      {{ name }}
    </th>
  </tr>
  <tr :class="$attrs.class">
    <th
      v-if="!isMobile"
      :headers="`th-label-${uid} th-price-${parentUid}`"
      scope="row"
    >
      {{ name }}
    </th>
    <td
      class="db-package-price"
      :headers="isMobile ? `th-label-${uid} th-price-${parentUid}` : undefined"
    >
      {{ roundedPrice }}
    </td>
    <td
      class="db-package-quantity"
      :headers="isMobile ? `th-label-${uid} th-quantity-${parentUid}` : undefined"
    >
      {{ quantity }}
    </td>
    <td
      v-if="!addonId"
      class="db-package-total"
      :headers="isMobile ? `th-label-${uid} th-total-${parentUid}` : undefined"
    >
      {{ $t('Included') }}
    </td>
    <td
      v-else
      class="db-package-total"
      :headers="isMobile ? `th-label-${uid} th-total-${parentUid}` : undefined"
    >
      {{ roundedTotal }}
    </td>
    <td
      v-if="addonId"
      class="db-package-action"
      :headers="isMobile ? `th-label-${uid} th-action-${parentUid}` : undefined"
    >
      <button
        class="db-button-square db-button-small db-edit"
        type="button"
        v-on:click="$emit('edit', addonId)"
      >
        <IconDbEdit
          width="16"
          height="16"
        />
        <span class="db-visually-hidden">
          {{ $t('Edit') }}
        </span>
      </button>
      <button
        class="db-button-square db-button-small db-delete"
        type="button"
        v-on:click="$emit('delete', addonId)"
      >
        <IconDbDelete
          width="16"
          height="16"
        />
        <span class="db-visually-hidden">
          {{ $t('Delete') }}
        </span>
      </button>
    </td>
    <td
      v-else
      class="db-package-action db-blocked"
      :headers="isMobile ? `th-label-${uid} th-action-${parentUid}` : undefined"
    >
      <IconDbBlocked
        width="16"
        height="16"
      />
    </td>
  </tr>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { v4 as uuidv4 } from 'uuid'
import { getCurrencySign } from '@/utils/currency'

const props = defineProps<{
  /** uid of the parent, to build the `headers` ids */
  parentUid: string
  /** useBreakpoints desktop */
  isMobile: boolean
  addonId?: string
  name: string
  quantity: number
  currencyCode?: string
  price?: number
  total?: number
}>()

defineEmits<{
  (e: 'delete', index: number): void
  (e: 'edit', index: number): void
}>()

/** Unique id */
const uid = uuidv4()

const roundedPrice = computed(() => {
  return props.price
    ? `${getCurrencySign(String(props.currencyCode ?? 'USD'))}${(
        Math.round(props.price * 100) / 100
      ).toFixed(2)}`
    : undefined
})
const roundedTotal = computed(() => {
  return props.total
    ? `${getCurrencySign(String(props.currencyCode ?? 'USD'))}${(
        Math.round(props.total * 100) / 100
      ).toFixed(2)}`
    : undefined
})
</script>
